import axios from 'axios';

export default (baseURL) => {
  const ax = axios.create({
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  ax.interceptors.request.use(
    (reqConfig) => {
      reqConfig.headers.authorization = `Bearer ${localStorage.getItem('access_token')}`; // eslint-disable-line no-param-reassign
      return reqConfig;
    },
    (err) => Promise.reject(err),
  );

  return ax;
};
